/**
 * getPortalContainer - تشخیص container مناسب برای پورتال در حالت فول‌اسکرین
 *
 * در iOS فول‌اسکرین واقعی کار نمی‌کند و باید از کلاس .video-container.fullscreen استفاده شود.
 * در سایر مرورگرها از Fullscreen API استفاده می‌شود با fallback به DOM query.
 *
 * @param {boolean} isIOS - آیا دستگاه iOS است
 * @param {boolean} isFullscreen - آیا ویدئو در حالت فول‌اسکرین است
 * @returns {HTMLElement} container مناسب برای ReactDOM.createPortal
 */
export const getPortalContainer = (isIOS, isFullscreen) => {
  // iOS: فول‌اسکرین واقعی نداریم، container کلاس fullscreen رو برگردون
  if (isIOS && isFullscreen) {
    const videoContainer = document.querySelector(
      ".video-container.fullscreen",
    );
    if (videoContainer) return videoContainer;
  }

  // سایر مرورگرها: از Fullscreen API استفاده کن
  if (!isIOS && isFullscreen) {
    const fullscreenElement =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (fullscreenElement) return fullscreenElement;

    // fallback: اگر Fullscreen API جواب نداد
    const videoContainer = document.querySelector(
      ".video-container.fullscreen",
    );
    if (videoContainer) return videoContainer;
  }

  // حالت عادی: body
  return document.body;
};
